import axios from 'axios'
import AuthToken from '@/auth/auth-token'
import { paginate } from './paginate'

class ApiBase {
  constructor () {
    const base = axios.create({
      baseURL: process.env.VUE_APP_BASE_API,
      withCredentials: false,
      headers: {
        'Content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
      }
    })

    this.api = base
  }
}

class Keys extends ApiBase {
  async getList (limit, offset, paging = true) {
    await AuthToken.setAuth(this.api)

    if (paging) {
      const url = 'v1'
      return paginate(this.api, url, limit, offset)
    }
    return this.api({
      url: `v1/${limit}/${offset}`,
      method: 'GET'
    })
  }

  async get (id) {
    await AuthToken.setAuth(this.api)

    return this.api({
      url: `v1/key/${id}`,
      method: 'GET'
    })
  }

  async post (data) {
    await AuthToken.setAuth(this.api)

    return this.api({
      url: 'v1/key',
      method: 'POST',
      data: data
    })
  }

  async put (id, data) {
    await AuthToken.setAuth(this.api)

    return this.api({
      url: `v1/key/${id}`,
      method: 'PUT',
      data: data
    })
  }
}

class KeyValues extends ApiBase {
  async post (data) {
    await AuthToken.setAuth(this.api)

    return this.api({
      url: 'v1/key_value',
      method: 'POST',
      data: data
    })
  }

  async get (uuid) {
    await AuthToken.setAuth(this.api)

    return this.api({
      url: `v1/key_value/${uuid}`,
      method: 'GET'
    })
  }

  async getList (keyId, limit, offset, paging = true) {
    await AuthToken.setAuth(this.api)

    if (paging) {
      const url = `v1/key_value/${keyId}`
      return paginate(this.api, url, limit, offset)
    }
    return this.api({
      url: `v1/key_value/${keyId}/${limit}/${offset}`,
      method: 'GET'
    })
  }

  async put (uuid, data) {
    await AuthToken.setAuth(this.api)

    return this.api({
      url: `v1/key_value/${uuid}`,
      method: 'PUT',
      data: data
    })
  }
}

export default {
  keys: new Keys(),
  keyValues: new KeyValues()
}
